module.exports = __webpack_public_path__ + "img/shutterstock_1064530364-scaled.a4a85efb.jpeg";